import React from 'react';
import SignupForm from '../components/SignupForm';
const Signup = () => <SignupForm />;
export default Signup;
